import { useIntl } from 'react-intl';

import { Notice } from '@calm-web/design-system';

import messages from './messages';
import { Form, SubmitButton, Wrapper } from './styles';
import { ProfileFormWrapperProps } from './types';

const ProfileFormWrapper = ({
	children,
	onSubmit,
	isSubmitting,
	isSubmittable,
	noticeMessage,
	formId,
}: ProfileFormWrapperProps) => {
	const { formatMessage } = useIntl();
	return (
		<Wrapper>
			<Form onSubmit={onSubmit} id={formId}>
				{children}
				<SubmitButton
					fullWidth
					backgroundColor="accessibleBrandGradient"
					type="submit"
					isDisabled={!isSubmittable() || isSubmitting}
					legacyOnClick={onSubmit}
					isLoading={isSubmitting}
				>
					{formatMessage(messages.cta)}
				</SubmitButton>
				{noticeMessage.message && (
					<Notice isSuccess={Boolean(noticeMessage.isSuccess)} describedBy={formId}>
						{formatMessage(noticeMessage.message)}
					</Notice>
				)}
			</Form>
		</Wrapper>
	);
};

export default ProfileFormWrapper;
